import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Image from "next/image";
import { useGetBrandsOptionsQuery } from "@app/store/filtersOptionsApi";
import { AppState } from "@app/store/store";
import { Brand } from "@app/store/types";
import { CustomLoader } from "@shared/ui/CustomLoader";
import { getActions } from "../../../../utils/utils";
import MaterialTextInput from "../../../UI/Buttons/MaterialTextInput/MaterialTextInput";
import SmallBrandsList from "../SmallBrandsList/SmallBrandsList";
import { popularBrandsConfig } from "./config";
import { BrandSelectorProps } from "./types";
import classes from "./BrandSelector.module.scss";

const BrandSelector = ({ storeName = "postForm" }: BrandSelectorProps) => {
    const dispatch = useDispatch();
    const actions = getActions(storeName);
    const YANDEX_STORAGE_URL = process.env.NEXT_PUBLIC_YANDEX_STORAGE_URL + "/logos/";

    const { data: brandsOptions, isFetching: brandsOptionsIsFetching } = useGetBrandsOptionsQuery(
        {}
    );

    const selectedBrand = useSelector((state: AppState) => state[storeName].selectedBrand);
    const [brandValue, setBrandValue] = useState("");
    useEffect(() => {
        if (selectedBrand) {
            setBrandValue(selectedBrand.name);
        } else {
            setBrandValue("");
        }
    }, [selectedBrand]);

    const filteredBrands =
        brandValue && brandsOptions
            ? brandsOptions.filter((brand: Brand) =>
                  brand.name.toLowerCase().includes(brandValue.toLowerCase())
              )
            : brandsOptions || [];

    const [popularBrands, _setPopularBrands] = useState<Brand[]>(popularBrandsConfig);

    const selectBrand = (brand: Brand) => {
        dispatch(actions.setBrand(brand));
        setBrandValue(brand.name);
    };

    const [popularBrandsVisible, setPopularBrandsVisible] = useState(true);
    useEffect(() => {
        if (selectedBrand && selectedBrand.name === brandValue) {
            setPopularBrandsVisible(false);
        } else {
            setPopularBrandsVisible(true);
        }
    }, [selectedBrand, brandValue]);

    const handleClickBrand = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        brand: Brand
    ) => {
        const foundBrand = brandsOptions?.find((bo: Brand) => bo.alias === brand.alias);
        selectBrand({
            ...brand,
            id: foundBrand?.id || brand.id
        });
    };

    return (
        <div className={classes["brand-selector"]}>
            <MaterialTextInput
                value={brandValue || ""}
                label="Выберите марку автомобиля"
                onChange={(val) => {
                    setBrandValue(val);
                    if (!val) {
                        if (storeName === "editForm") {
                            dispatch(actions.setBrand(val));
                        } else {
                            dispatch(actions.setBrand(undefined));
                        }
                    }
                }}
            />

            {popularBrandsVisible && (
                <>
                    <h3>Популярные марки</h3>

                    {popularBrands.length === 0 && (
                        <div className={classes["brand-selector__empty"]}>
                            <span>
                                В нашей базе не таких марок,{" "}
                                <a
                                    onClick={(e) => {
                                        e.preventDefault();
                                        alert(
                                            "тут нужно уточнить, даем ли возможность создавать бренды?"
                                        );
                                    }}
                                    href=""
                                >
                                    создать марку?
                                </a>
                            </span>
                        </div>
                    )}
                    {brandsOptionsIsFetching ? (
                        <CustomLoader />
                    ) : (
                        <>
                            <div className={classes["popular-brands"]}>
                                {popularBrandsConfig.map((brand, index) => (
                                    <div
                                        onClick={(e) => handleClickBrand(e, brand)}
                                        key={index}
                                        className={classes["popular-brand"]}
                                    >
                                        <Image
                                            src={`${YANDEX_STORAGE_URL}${brand.alias}.webp`}
                                            alt={brand.name}
                                            width={36}
                                            height={36}
                                            unoptimized={true}
                                            onError={(e) => {
                                                e.currentTarget.src = "/img/placeholder-brand.png";
                                                e.currentTarget.srcset =
                                                    "/img/placeholder-brand.png";
                                            }}
                                        />
                                        <span className={classes["popular-brand__text"]}>
                                            {brand.name}
                                        </span>
                                    </div>
                                ))}
                            </div>

                            <div className={classes["brand-selector__divider"]} />

                            <SmallBrandsList
                                brands={filteredBrands || []}
                                onChanged={(item) => {
                                    selectBrand(item);
                                }}
                                isLoading={brandsOptionsIsFetching}
                                expandLabel="Показать все марки"
                            />
                        </>
                    )}
                </>
            )}
        </div>
    );
};
export default BrandSelector;